import { API_BASE_URL } from '../../../config/api';
import type { RealtimeStats, StatisticsReport } from '../models';

/**
 * 통계 데이터 접근 계층
 * API 호출을 담당
 */
export class StatisticsRepository {
  private getHeaders(): HeadersInit {
    const token = localStorage.getItem('accessToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  /**
   * 실시간 통계 조회
   */
  async getRealtimeStats(): Promise<RealtimeStats> {
    const response = await fetch(`${API_BASE_URL}/v1/statistics/realtime`, {
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch realtime statistics');
    }

    const data = await response.json();
    return data.data;
  }

  /**
   * 일간 리포트 조회
   */
  async getDailyReport(): Promise<StatisticsReport> {
    const response = await fetch(`${API_BASE_URL}/v1/statistics/report/daily`, {
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch daily report');
    }

    const data = await response.json();
    return data.data;
  }

  /**
   * 주간 리포트 조회
   */
  async getWeeklyReport(): Promise<StatisticsReport> {
    const response = await fetch(`${API_BASE_URL}/v1/statistics/report/weekly`, {
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch weekly report');
    }

    const data = await response.json();
    return data.data;
  }

  /**
   * 월간 리포트 조회
   */
  async getMonthlyReport(): Promise<StatisticsReport> {
    const response = await fetch(`${API_BASE_URL}/v1/statistics/report/monthly`, {
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch monthly report');
    }

    const data = await response.json();
    return data.data;
  }

  /**
   * 리포트 내보내기
   */
  async exportReport(reportType: string, format: string): Promise<{ download_url: string }> {
    const response = await fetch(
      `${API_BASE_URL}/v1/statistics/export/${reportType}?format=${format}`,
      {
        headers: this.getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to export report');
    }

    const data = await response.json();
    return data.data;
  }
}

// 싱글톤 인스턴스
export const statisticsRepository = new StatisticsRepository();
